import api from "../utils/axios";

export async function changePassword(form) {
  try {
    const res = await api.post(`/auth/change-password`, form);
    return res.data;
  } catch (error) {
    throw error.response;
  }
}

// export async function changePassword(
//   userId,
//   newPassword
// ) {
//   const response = await fetch(
//     `${API}/users/${userId}`,
//     {
//       method: "PATCH",
//       headers: {
//         "Content-Type":
//           "application/json",
//       },
//       body: JSON.stringify({
//         password: newPassword,
//       }),
//     }
//   );

//   return response.json();
// }

